import ErrorPanel from './ErrorPanel.component';

export default ErrorPanel;
